<div class="content-wrapper">
    <div class="content-body">
        <section id="dataToFilter">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'COUNSELLOR_ASSIGN'">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Assign Counsellor - {{ selectedStudent?.name }}</span>
                        </h4>
                        <h4 *ngIf="modalType === 'FOLLOW_UP'">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Follow Up - {{ selectedStudent?.name }}</span>
                        </h4>
                        <h4 *ngIf="modalType === 'VIEW_FOLLOW_UP_REMARKS'">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Follow Up Remarks - {{ selectedStudent?.name }}</span>
                        </h4>
                        <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
                           (click)="this.modalService.dismissAll('')"></i>
                    </div>
                    <div class="modal-body">
                        <div class="row" *ngIf="modalType === 'COUNSELLOR_ASSIGN'">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                            <form class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12 form mt-2 shadow-none"
                                  novalidate [formGroup]="assignCounsellorForm">
                                <div class="form-group">
                                    <label for="assigned_to">Assign Counsellor</label>
                                    <select class="form-control" id="assigned_to" formControlName="assigned_to">
                                        <option value="">Select Counsellor</option>
                                        <option [value]="counsellor?.user?.id"
                                                *ngFor="let counsellor of counsellors">{{ counsellor?.user?.name }}
                                        </option>
                                    </select>
                                    <small *ngIf="submitted && assignCounsellorForm.get('assigned_to').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </form>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                        </div>

                        <div class="row justify-content-center" *ngIf="modalType === 'FOLLOW_UP'">
                            <form
                                    class="col-xl-6 col-lg-8 col-md-10 col-sm-12 form mt-2 shadow-none"
                                    novalidate
                                    [formGroup]="followUpForm"
                            >
                                <div class="form-group">
                                    <label for="subject">Subjects</label>
                                    <input
                                            class="form-control"
                                            type="text" id="subject"
                                            formControlName="subject"
                                            placeholder="Enter Subjects"
                                    />
                                    <small
                                            *ngIf="submitted && followUpForm.get('subject').hasError('required')"
                                            class="text-danger"
                                    >
                                        Field is required.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label for="stage_id">Stage</label>


                                    <select class="form-control" id="stage_id" formControlName="stage_id"
                                            (change)="getReasonsFollowups($event)">
                                        <option value="">Select Stage</option>
                                        <option [value]="stage?.id"
                                                *ngFor="let stage of allStages">{{ stage.name }}
                                        </option>
                                    </select>
                                    <small
                                            *ngIf="submitted && followUpForm.get('stage_id').hasError('required')"
                                            class="text-danger"
                                    >
                                        Field is required.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label for="reason_id">Reason</label>
                                    <select class="form-control" id="reason_id" formControlName="reason_id">
                                        <option value="">Select Reason</option>
                                        <option [value]="reason?.id"
                                                *ngFor="let reason of reasonFollowups">{{ reason?.reasons.name }}
                                        </option>
                                    </select>
                                    <small
                                            *ngIf="submitted && followUpForm.get('reason_id').hasError('required')"
                                            class="text-danger"
                                    >
                                        Field is required.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label for="type">Follow Up</label>
                                    <select class="form-control" id="type" formControlName="type">
                                        <option value="">Select Type</option>
                                        <option value="CALL">Call</option>
                                        <option value="WHATS_APP">Whats app</option>
                                        <option value="TEXT_MESSAGE">Text Message</option>

                                    </select>
                                    <small
                                            *ngIf="submitted && followUpForm.get('type').hasError('required')"
                                            class="text-danger"
                                    >
                                        Field is required.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label for="remark">Remarks</label>
                                    <input id="remark"
                                           class="form-control"
                                           type="text"
                                           formControlName="remark"
                                           placeholder="Example"
                                    />
                                </div>
                            </form>
                        </div>

                        <div class="card height-equal notifications" *ngIf="modalType === 'VIEW_FOLLOW_UP_REMARKS'">
                            <div class="card1-body pt-0" style="height: 450px; overflow-y: scroll;"
                                 *ngIf="followUps && followUps.length > 0; else noFollowUpToShow">
                                <ul class="list-unstyled">
                                    <li *ngFor="let followups of followUps; let i = index">
                                        <ul class="list-unstyled">
                                            <li class="d-flex" *ngFor="let item of followups.lead_details;">
                                                <!-- Activity Dot -->
                                                <div class="activity-dot-primary"></div>
                                                <div class="card1 rounded-lg" style="width: 80%; max-width: 600px; margin: 0 auto;">
                                                    <!-- Event Content -->
                                                    <div class="timeline__event__content" style="min-width: 95%; margin: 0 auto; padding: 1rem; border: 1px solid #ddd;">
                                                        <div class="row ps-3" style="margin-left: 1rem;">
                                                            <!-- Title Section (Left-aligned) -->
                                                            <div class="row">
                                                                <div class="col-12 d-flex justify-content-between align-items-center w-100">
                                                                    <!-- Subject (flex-grow to take remaining space) -->
                                                                    <div class="flex-grow-1">
                                                                        <h5 class="fw-bolder text-primary">{{ item.subject }}</h5>
                                                                    </div>
                                                                    <!-- Date aligned to the right -->
                                                                    <div class="d-flex justify-content-end">
                                                                        <span class="text-dark">{{ item.date_time || 'N/A' }}</span>
                                                                    </div>
                                                                </div>

                                                                <!-- Event Description Section (Left-aligned with remaining space) -->
                                                                <div class="col-12">
                                                                    <p>
                                                                        <strong class="fw-bolder text-primary">Stage:  </strong>
                                                                        <span class="text-dark">{{ item?.stage?.name || 'N/A' }}</span>
                                                                    </p>
                                                                    <p>
                                                                        <strong class="fw-bolder text-primary">Reason:  </strong>
                                                                        <span class="text-dark">{{ item?.reason?.name || 'N/A' }}</span>
                                                                    </p>
                                                                    <p>
                                                                        <strong class="fw-bolder text-primary">Type:  </strong>
                                                                        <span class="text-dark">{{ item?.type || 'N/A' }}</span>
                                                                    </p>
                                                                    <p>
                                                                        <strong class="fw-bolder text-primary">Remark:  </strong>
                                                                        <span class="text-dark">{{ item.remark || 'N/A' }}</span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </li>
                                        </ul>
                                    </li>
                                </ul>

                            </div>


                            <ng-template #noFollowUpToShow>
                                <div class="col-12 text-center mt-4">
                                    <h6 class="text-muted"><i class="bi bi-exclamation-circle"></i> No follow-ups added
                                    </h6>
                                </div>
                            </ng-template>


                        </div>


                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success btn-raised" type="button"
                                *ngIf="modalType === 'COUNSELLOR_ASSIGN'"
                                (click)="assignCounsellor()">
                            Submit
                        </button>
                        <button class="btn btn-success btn-raised" type="button"
                                *ngIf="modalType === 'FOLLOW_UP'"
                                (click)="followUp()">
                            Submit
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Counseling</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="email" placeholder="Email">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="contact"
                                           placeholder="Contact">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="course"
                                           placeholder="Course">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">Search
                                </button>
                            </div>
                        </div>
                    </form>


                </div>
            </div>

            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list text-center">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"
                                                *ngIf="user && (['SUPER_ADMIN', ].indexOf(user['user_type']) !== -1)">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Counsellor</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Full
                                                Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Contact</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Email</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Remarks</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Course</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Counseling Date</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Counseling Time</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Date & Time</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="dataToFilter && dataToFilter.length > 0 && (!filteredData || filteredData.length === 0); else filteredTable">
                                        <tr *ngFor="let admin of dataToFilter; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{ (pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1 }}
                                                    .</h6>
                                            </td>

                                            <td class="text-center"><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.contact }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.email }}</h6></td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.remarks ? admin?.remarks : '--' }}</h6>
                                            </td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.course_name ? admin?.course_name : '--' }}</h6>
                                            </td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.counseling_date }}</h6>
                                            </td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.counseling_time }}</h6>
                                            </td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.created_at | date:'yyyy-MM-dd HH:mm:ss' }}</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #filteredTable>
                                            <tbody *ngIf="filteredData && filteredData.length > 0; else noDataToShowWeb">
                                            <tr *ngFor="let admin of filteredData; let i = index">
                                                <td class="text-center">
                                                    <h6 class="mt-1">{{ (pagination.page - 1) * pagination.perpage + i + 1 }}
                                                        .</h6>

                                                </td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.contact }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.email }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.course_name }}</h6>
                                                </td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.created_at | date:'yyyy-MM-dd HH:mm:ss' }}</h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                        <ng-template #noDataToShowWeb>
                                            <p>No data to show.</p>
                                        </ng-template>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Displaying Data on Small Screens -->
            <div class="row mt-3 d-block d-md-none"
                 *ngIf="dataToFilter && dataToFilter.length > 0; else noDataToShowMobile">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngFor="let admin of dataToFilter; let i = index">
                    <div class="card">
                        <div class="card-header bottom-shadow-light pb-18px">
                            <div class="row width-100-per">
                                <div class="col-6">
                                    <h4 class="card-title text-uppercase card-ellipsis">
                                        {{ (pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1 }}
                                        .
                                        {{ admin?.name }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
